
export default function Footer() {
  return (
    <footer className="relative" style={{ backgroundColor: '#30458B' }}>
      <div className="absolute top-0 left-0 right-0 h-[3px]" style={{ backgroundColor: '#F3220B' }}></div>
      <div className="max-w-7xl mx-auto px-6 pt-12 pb-6">
        <div className="flex flex-col md:flex-row justify-between items-start gap-10">
          {/* Left side - Links */}
          <div className="flex flex-col gap-6">
            {/* Navigation links */}
            <div className="flex flex-col gap-2">
              <a href="#about" className="text-white text-sm md:text-base hover:text-white/80 transition-colors cursor-pointer">
                About
              </a>
              <a href="#demo" className="text-white text-sm md:text-base hover:text-white/80 transition-colors cursor-pointer">
                Demo
              </a>
              <a href="#contact" className="text-white text-sm md:text-base hover:text-white/80 transition-colors cursor-pointer">
                Contact
              </a>
            </div>
            {/* Legal links */}
            <div className="flex flex-col gap-2">
              <a href="/legal-notice.html" className="text-white text-sm md:text-base hover:text-white/80 transition-colors cursor-pointer">
                Legal Notice and Terms of Use
              </a>
            </div>
          </div>

          {/* Right side - Social icons */}
          <div className="flex items-center gap-5">
            <a href="#" className="w-6 h-6 flex items-center justify-center text-white hover:text-white/80 transition-colors cursor-pointer" aria-label="LinkedIn">
              <i className="ri-linkedin-fill text-xl"></i>
            </a>
            <a href="#" className="w-6 h-6 flex items-center justify-center text-white hover:text-white/80 transition-colors cursor-pointer" aria-label="X">
              <i className="ri-twitter-x-fill text-xl"></i>
            </a>
          </div>
        </div>

        {/* Bottom center - Copyright */}
        <div className="mt-10 pt-6 border-t border-white/20 text-center">
          <p className="text-white text-xs md:text-sm">© CandyVoice 2026</p>
        </div>
      </div>
    </footer>
  );
}
